import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import SystemLabel from "./SystemLabel";
import { toJS } from "mobx";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export const ValidationSnackbar = observer((props) => {
  const { validations, register, modules, environment, fields, modulesRefs, globalAlert, questions, breakouts, current, validate, triggerValidation, orders, checkInvoiceValidation, getFilteredValidations, conditions } =
    props;

  let valids = getFilteredValidations();
  let isValid = checkInvoiceValidation(valids.length == 0);
  const filteredValidations = getFilteredValidations();
  const getLabel = (module) => {
    switch (module.type) {
      case "FIELD":
        return fields.find((f) => f.fieldId == module.settings.fieldId)?.fieldLanguage?.find((fl) => fl.languageCode == environment.lang)?.label;
      case "QUESTION":
        return questions.find((f) => f.questionId == module.settings.questionId)?.questionLanguage?.find((fl) => fl.languageCode == environment.lang)?.label;
      case "EVENT":
        return breakouts.find((f) => f.eventId == module.settings.eventId)?.name;
      default:
        return null;
    }
  };

  const scrollToNonValidModule = (contentModuleId) => {
    if (!modulesRefs) return;
    modulesRefs.current[contentModuleId].scrollIntoView({ block: "end", behavior: "smooth" });
  };

  if (globalAlert) {
    <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "left" }} open={true} onClose={() => null}>
      <Alert severity="error" style={{ maxWidth: 370 }}>
        {globalAlert}
      </Alert>
    </Snackbar>;
  }
  return !isValid && validate ? (
    <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "left" }} open={true} onClose={() => triggerValidation(false)}>
      <Alert severity="error" style={{ maxWidth: 370 }}>
        {filteredValidations
          .filter((v) => (v.page === current.activePage || v.page === 0) && v.valid == false)
          .map((v) => {
            const module = modules.find((m) => m.contentModuleId == v.id && (m.settings.validation || v.label));
            if ((v.id.toString().includes("INVOICE_") && current.payMethod == "invoice") || v.label == "PaymentOption") {
              return (
                <div key={v.id} onClick={() => scrollToNonValidModule(modules.find((m) => m.type == "PAYMENT_OPTIONS" || m.type == "PAYMENT_OPTIONS_TWO")?.contentModuleId)} className="validation-line">
                  * <SystemLabel textOnly name={"Invoice" + v.label} groupName="Form.Validation" />
                </div>
              );
            }
            if (module && v.valid == false) {
              let vMessage = null;
              if (v.reason && module.settings.validation[v.reason] && module.settings.validation[v.reason][environment.lang]) vMessage = module.settings.validation[v.reason][environment.lang];
              return (
                <div key={v.id} onClick={() => scrollToNonValidModule(module.contentModuleId)} className="validation-line">
                  * <strong>{v.label || getLabel(module)}:</strong> {v.message || (vMessage ? vMessage : <SystemLabel textOnly name={module.type + v.reason} groupName="Form.Validation" />)}
                </div>
              );
            }
            if (v?.decorator) {
              return (
                <div key={v.id} className="validation-line">
                  <SystemLabel textOnly name={"RequiredField" + v.decorator} groupName="Form.Validation" />
                </div>
              );
            }
            return null;
          })}
      </Alert>
    </Snackbar>
  ) : null;
});
